import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ProductGrid from "@/components/ProductGrid";
import TrustSection from "@/components/TrustSection";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-marble">
      <div className="marble-veil" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/marble-hero.png)` }} />
      <Navbar />
      <main>
        <Hero />
        <ProductGrid />
        <TrustSection />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
